import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Arrow,
  ArrowWrapper,
  Circle,
  CircleWrapper,
  Container,
  Image,
  IMAGE_GAP,
  ImageWrapper,
  Label,
  LabelWrapper,
  Wrapper
} from './components';

import Lightbox from '../Lightbox';

class Carousel extends Component {
  static propTypes = {
    specs: PropTypes.arrayOf(
      PropTypes.shape({
        images: PropTypes.arrayOf(PropTypes.string).isRequired,
        labels: PropTypes.arrayOf(PropTypes.string).isRequired
      })
    )
  };

  state = {
    active: 0,
    label: null,
    src: null
  };

  left = max => {
    this.setState(state => ({
      active: state.active === max ? max : state.active + 1
    }));
  };

  right = () => {
    this.setState(state => ({
      active: state.active === 0 ? 0 : state.active - 1
    }));
  };

  render() {
    const { specs } = this.props;
    const { active, label, src } = this.state;
    const combined =
      specs &&
      specs
        .map(spec =>
          spec.images.map((src, i) => ({
            src,
            label: spec.labels && spec.labels.length > 0 && spec.labels[i]
          }))
        )
        .pop();
    return (
      <React.Fragment>
        {src && (
          <Lightbox
            label={label}
            onClose={() => this.setState({ src: null })}
            src={src}
          />
        )}
        <Container>
          {active !== 0 && combined.length > 3 && (
            <ArrowWrapper left onClick={this.right}>
              <Arrow left />
            </ArrowWrapper>
          )}
          <Wrapper center={combined.length < 3}>
            {combined.map((spec, i) => (
              <ImageWrapper
                key={i}
                onClick={() =>
                  this.setState({ label: spec.label, src: spec.src })
                }
                translate={-active * 100}
                translate2={-active * IMAGE_GAP}
              >
                <Image src={spec.src} />
                <LabelWrapper>
                  <Label>{spec.label}</Label>
                </LabelWrapper>
              </ImageWrapper>
            ))}
          </Wrapper>
          {active !== combined.length - 3 && combined.length > 3 && (
            <ArrowWrapper onClick={() => this.left(combined.length - 3)}>
              <Arrow />
            </ArrowWrapper>
          )}
        </Container>
        <CircleWrapper>
          {combined.map((_, i) => (
            <Circle key={i} active={i <= active + 2 && i > active - 1} />
          ))}
        </CircleWrapper>
      </React.Fragment>
    );
  }
}

export default Carousel;
